<template>
  
</template>

<script>
export default {
    created(){
        localStorage.removeItem("jwt")
        setTimeout(() => {
            window.location = '/login'
        }, 1000);
    }
}
</script>

<style>

</style>